module.exports = __webpack_public_path__ + "static/media/whichThinnerTableBelow.9cc27aa3.mp3";